import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

export interface SalesPoint {
  day: string;
  dineIn: number;
  takeaway: number;
  aggregator: number;
}

interface SalesChartProps {
  data: SalesPoint[];
}

export default function SalesChart({ data }: SalesChartProps) {
  const hasSales = data.some((d) => d.dineIn + d.takeaway + d.aggregator > 0);

  return (
    <div className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-5">
      <div className="flex items-center justify-between mb-4">
        <h4 className="text-sm font-semibold text-foreground-800">Sales Trend</h4>
        <div className="flex items-center gap-3">
          {['Dine-in', 'Takeaway', 'Aggregator'].map((label, i) => (
            <div key={label} className="flex items-center gap-1.5">
              <div
                className={`w-2.5 h-2.5 rounded-sm ${
                  i === 0 ? 'bg-primary-400' : i === 1 ? 'bg-secondary-400' : 'bg-accent-400'
                }`}
              ></div>
              <span className="text-xs text-foreground-500">{label}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="h-56 md:h-64">
        {hasSales ? (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} barGap={0} barCategoryGap="30%">
              <CartesianGrid strokeDasharray="3 3" stroke="oklch(var(--background-200))" vertical={false} />
              <XAxis dataKey="day" axisLine={false} tickLine={false} tick={{ fill: 'oklch(var(--foreground-500))', fontSize: 12 }} />
              <YAxis axisLine={false} tickLine={false} tick={{ fill: 'oklch(var(--foreground-500))', fontSize: 12 }} tickFormatter={(v) => `₹${(v / 1000).toFixed(0)}k`} />
              <Tooltip
                contentStyle={{
                  backgroundColor: 'oklch(var(--background-50))',
                  border: '1px solid oklch(var(--background-200))',
                  borderRadius: '8px',
                  fontSize: '12px',
                }}
                formatter={(value: number) => [`₹${value.toLocaleString('en-IN')}`, '']}
              />
              <Bar dataKey="dineIn" fill="oklch(var(--primary-400))" radius={[4, 4, 0, 0]} />
              <Bar dataKey="takeaway" fill="oklch(var(--secondary-400))" radius={[4, 4, 0, 0]} />
              <Bar dataKey="aggregator" fill="oklch(var(--accent-400))" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <div className="h-full flex flex-col items-center justify-center gap-2 text-center">
            <i className="ri-bar-chart-2-line text-2xl text-foreground-300"></i>
            <p className="text-sm text-foreground-400">No sales in this period</p>
          </div>
        )}
      </div>
    </div>
  );
}
